var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBolaTratamientos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#4582C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_314_1974)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72266 15.2067L6.03768 14.6392C5.30465 14.0318 5.20243 12.9414 5.8098 12.2084L8.72269 8.69282L12.0664 11.4633L9.15346 14.9788C8.5461 15.7119 7.45569 15.8141 6.72266 15.2067ZM14.55 4.36562L15.235 4.93318C15.968 5.54054 16.0703 6.63096 15.4629 7.36399L12.55 10.8795L9.20636 8.10908L12.1192 4.59353C12.7266 3.8605 13.817 3.75826 14.55 4.36562ZM16.0469 7.84788C16.9211 6.79282 16.7737 5.22312 15.7189 4.34916L15.0339 3.78161C13.9789 2.90741 12.4094 3.05454 11.5352 4.10961L8.47634 7.80135C8.43151 7.82402 8.39048 7.85609 8.35635 7.89727C8.32223 7.93846 8.29856 7.98447 8.28462 8.03273L5.22576 11.7245C4.35157 12.7795 4.49871 14.349 5.55378 15.2232L6.23876 15.7907C7.29354 16.6647 8.86328 16.5178 9.73748 15.4627L16.0469 7.84788Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_1974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.2283,
    height: 6.31419,
    fill: "white",
    transform: "translate(3.50409 13.5986) rotate(-50.3559)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolaTratamientos);
export default __webpack_public_path__ + "static/media/bola-tratamientos.d3d871341a3865a73d928d8dc5dbbf98.svg";
export { ForwardRef as ReactComponent };